var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0002 14C25.5335 14 24.3335 15.2 24.3335 16.6667V17.0534C20.4934 18.1867 17.6667 21.7601 17.6667 26.0002V34.0003L15 36.667V38.0003H27.4668C27.1591 37.1448 27.0012 36.2427 27.0002 35.3336H20.3334V26.0002C20.3334 22.3201 23.3201 19.3334 27.0002 19.3334C30.6802 19.3334 33.6669 22.3201 33.6669 26.0002V27.4535C34.5487 27.2945 35.4518 27.2945 36.3336 27.4535V26.0002C36.3336 21.7601 33.5069 18.1867 29.6669 17.0534V16.6667C29.6669 15.9594 29.3859 15.2812 28.8858 14.7811C28.3857 14.281 27.7074 14 27.0002 14ZM33.6669 30.0002V34.0003H29.6669V36.667H33.6669V40.667H36.3336V36.667H40.3337V34.0003H36.3336V30.0002M24.3335 39.3337C24.3335 39.9031 24.5159 40.4576 24.8538 40.9159C25.1918 41.3742 25.6675 41.7123 26.2115 41.8807C26.7555 42.0491 27.3391 42.039 27.8768 41.8518C28.4146 41.6646 28.8784 41.3101 29.2002 40.8403C28.7735 40.387 28.4002 39.8803 28.0802 39.3337H24.3335Z",
    fill: "url(#paint0_linear_4712_32579)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4712_32579",
    x1: 15,
    y1: 14,
    x2: 42.8604,
    y2: 39.2073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.68e6a674d983a761d338301f03edfca6.svg";
export { ForwardRef as ReactComponent };